<div class="bell wm-usernotifications-container" (click)="openUserNotifications()">
  <div class="wm-usernotifications-label" data-testing-id="usernotifications-label">
    <fa-icon size="lg" [icon]="faBell"></fa-icon>
  </div>
  @if (newNotificationsAvailable) {
    <div class="new-notifications"></div>
  }
</div>
